import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import InputEvaluatesForm from '../InputEvaluatesForm'
import { getProjectEvaluation } from '../../../redux/actions/projectEvaluation'

export default function DirectorEvaluateCloseProjectWidgets(props) {
  const { projectId, projectProgressId } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [formSchema, setFormSchema] = useState()

  useEffect(() => {
    handleGetEvaluationSchema(projectId, projectProgressId)
  }, [])

  const handleGetEvaluationSchema = async (projectId, projectProgressId, evaluationId) => {
    try {
      const response = await getProjectEvaluation(projectId, projectProgressId, evaluationId)

      setFormSchema(response.forms)
      // console.log('response==>', response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
  }

  return (
    <>
      {formSchema?.evaluationRounds?.length > 0 &&
        formSchema?.evaluationRounds?.map((rounds) => {
          // console.log('rounds', rounds)
          return (
            <Panel
              header={rounds.header}
              key={rounds.period}
              shaded
              bordered
              collapsible
              defaultExpanded
              style={{ marginBottom: '1em' }}
            >
              {rounds?.evaluations?.length > 0 &&
                rounds?.evaluations?.map((evaluations) => {
                  // console.log('evaluations', evaluations)
                  return (
                    <Panel
                      header={evaluations.name}
                      key={evaluations.code}
                      style={{ marginTop: -20 }}
                    >
                      {evaluations?.questions?.length > 0 && (
                        <InputEvaluatesForm
                          mode={'VIEW'}
                          schema={evaluations?.questions}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          getValues={getValues}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          setIsEnableEdit={setIsEnableEdit}
                        />
                      )}
                    </Panel>
                  )
                })}
            </Panel>
          )
        })}
    </>
  )
}
